// ⚡ Feed the POG'CAPACITOR from anywhere (server caps 30/day/user)
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let last = 0;

export const feedCapacitor = () => {
  const now = Date.now();
  if (now - last < 15000) return;
  last = now;
  axios.post(`${API}/capacitor/feed`, {}, { withCredentials: true }).catch(() => {});
};
